import React from 'react';
import {useTranslation} from 'react-i18next';
import {MagnifyingGlass} from '../../icons';
import {USAGE_SORT} from '../../portal_usage/portalUsageState';

/**
 * Búsqueda y orden del ranking, 100 % client-side sobre el payload — mismo criterio que el
 * Listado de Clientes v2: la respuesta ya trae todos los clientes, así que filtrar en el servidor
 * sería una llamada por tecleo para reordenar datos que el navegador ya tiene.
 */
export function PortalUsageToolbar({search, onSearch, sort, onSort, shown, total}) {
    const {t} = useTranslation();

    return (
        <div className="pu-rank__toolbar">
            <label className="pu-search">
                <MagnifyingGlass size={15}/>
                <input
                    type="search"
                    value={search}
                    onChange={event => onSearch(event.target.value)}
                    placeholder={t('portal_usage.rank_search', 'Buscar cliente')}
                    aria-label={t('portal_usage.rank_search', 'Buscar cliente')}
                />
            </label>

            <span className="pu-rank__count">
                {shown === total
                    ? t('portal_usage.rank_count_all', '{{n}} clientes', {n: total})
                    : t('portal_usage.rank_count_filtered', '{{shown}} de {{total}} clientes',
                        {shown, total})}
            </span>

            <label className="pu-rank__sort">
                <span className="pu-rank__sort-label">{t('portal_usage.rank_sort', 'Ordenar por')}</span>
                <select value={sort} onChange={event => onSort(event.target.value)}>
                    {/* El default no es alfabético ni por volumen: una lista ordenada por consultas
                        pone arriba a los clientes que ya están bien. */}
                    <option value={USAGE_SORT.ATTENTION}>
                        {t('portal_usage.rank_sort_attention', 'Los que dejaron de usar primero')}
                    </option>
                    <option value={USAGE_SORT.QUERIES}>
                        {t('portal_usage.rank_sort_queries', 'Más consultas al chat')}
                    </option>
                    <option value={USAGE_SORT.REPORT_VIEWS}>
                        {t('portal_usage.rank_sort_reports', 'Más ingresos a informes')}
                    </option>
                    <option value={USAGE_SORT.SHARED}>
                        {t('portal_usage.rank_sort_shared', 'Más informes compartidos')}
                    </option>
                    <option value={USAGE_SORT.LAST}>
                        {t('portal_usage.rank_sort_last', 'Actividad más reciente')}
                    </option>
                    <option value={USAGE_SORT.NAME}>
                        {t('portal_usage.rank_sort_name', 'Nombre')}
                    </option>
                </select>
            </label>
        </div>
    );
}

export default PortalUsageToolbar;
